<div class="container-fluid dashboard-container">


    <!-- Date Filter and Download Button -->
    <div class="row mb-4">
        <mat-card class="h-100">
            <mat-card-content>
                <div class="col-12 d-flex justify-content-between align-items-center flex-wrap gap-2">
                    <div class="filter-bar d-flex flex-wrap gap-3 align-items-center">
                        <button mat-stroked-button color="primary" (click)="openDateRangeDialog()"
                            aria-label="Open date range filter"
                            class="date-filter-btn d-flex justify-content-between align-items-center">
                            <span>Filter by Date</span>
                            <mat-icon class="calendar-icon">calendar_today</mat-icon>
                        </button>
                    </div>
                    <!-- <div class="download-button">
            <button mat-raised-button (click)="downloadReport()" aria-label="Download report">
              <mat-icon>download</mat-icon>
              Download Report
            </button>
          </div> -->
                </div>
            </mat-card-content>
        </mat-card>
    </div>
    <div class="row">
        <mat-tab-group class="tab-cards" mat-stretch-tabs="false" mat-align-tabs="start" animationDuration="0ms">
            <mat-tab label="Demographics">
                <ng-template mat-tab-label>
                    <span class="mat-tab-label">Demographics</span>
                </ng-template>
                <div class="row">
                    <div class="col-12 col-lg-6 mb-4">
                        <mat-card class="chart-card h-100">
                            <mat-card-header *ngIf="baseService.countryChartData.length > 0">
                                <div class="card-header-stack">
                                    <div class="card-header-top">
                                        <mat-card-title class="custom-card-title card-title-with-tooltip">
                                            <span class="card-title-text">Learner Distribution by Country</span>
                                            <button
                                                type="button"
                                                class="what-is-this"
                                                matTooltipClass="dashboard-tooltip"
                                                [matTooltip]="tooltips.text('learnerDistributionByCountry')"
                                                aria-label="What is this? Learner Distribution by Country">
                                                <mat-icon aria-hidden="true">info</mat-icon>
                                                What is this?
                                            </button>
                                        </mat-card-title>
                                        <mat-card-subtitle class="custom-country-subtitle">
                                            Most engaged learners by country
                                        </mat-card-subtitle>
                                    </div>

                                    <mat-divider class="header-divider"></mat-divider>
                                </div>
                            </mat-card-header>
                            <mat-card-content *ngIf="baseService.countryChartData.length === 0">
                                <mat-spinner diameter="40" aria-label="Loading Country"></mat-spinner>
                            </mat-card-content>
                            <mat-card-content *ngIf="baseService.countryChartData.length > 0">
                                <app-africa-map
                                    [countryData]="baseService.countryIndexData">
                                </app-africa-map>
                                <h3 class="statistics-heading">Detailed Statistics</h3>
                                <mat-divider></mat-divider>
                                <div class="index-list">
                                    <div *ngFor="let item of baseService.countryIndexData; let i = index"
                                        class="index-item">
                                        <span class="color-dot" [style.backgroundColor]="item.color"></span>
                                        <div class="point-name">
                                            <span>{{ item.name }}</span>
                                            <div class="point-stuff">
                                                {{ item.percentage }}% - {{ item.count | number }} learners
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </mat-card-content>
                        </mat-card>
                    </div>
                    <div class="col-12 col-lg-6 mb-4">
                        <mat-card class="chart-card h-100">
                            <mat-card-header *ngIf="baseService.provinceIndexData.length > 0">
                                <div class="card-header-stack">
                                    <div class="card-header-top">
                                        <mat-card-title class="custom-card-title card-title-with-tooltip">
                                            <span class="card-title-text">Learner Breakdown by Province</span>
                                            <button
                                                type="button"
                                                class="what-is-this"
                                                matTooltipClass="dashboard-tooltip"
                                                [matTooltip]="tooltips.text('learnerBreakdownByProvince')"
                                                aria-label="What is this? Learner Breakdown by Province">
                                                <mat-icon aria-hidden="true">info</mat-icon>
                                                What is this?
                                            </button>
                                        </mat-card-title>
                                        <mat-card-subtitle class="date-label">{{ baseService.dateRange }}</mat-card-subtitle>
                                    </div>

                                    <mat-divider class="header-divider"></mat-divider>

                                    <div class="header-filter-right-wrapper">
                                        <mat-form-field appearance="outline" class="header-filter under-header">
                                            <mat-label>Filter by Province</mat-label>
                                            <mat-select [(ngModel)]="baseService.selectedProvince"
                                                (selectionChange)="onProvinceFilterChange()" aria-label="Filter by province"
                                                multiple>
                                                <mat-option [value]="null">All Provinces</mat-option>
                                                <mat-option *ngFor="let province of baseService.provinces; let i = index"
                                                    [value]="province.fullName">
                                                    <span class="color-dot"
                                                        [style.backgroundColor]="baseService.colorPalettes['province'][i % baseService.colorPalettes['province'].length]"></span>
                                                    {{ province.fullName }}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>
                                </div>
                            </mat-card-header>
                            <mat-card-content *ngIf="baseService.provinceIndexData.length === 0">
                                <mat-spinner diameter="40" aria-label="Loading Province Breakdown"></mat-spinner>
                            </mat-card-content>
                            <mat-card-content *ngIf="baseService.provinceIndexData.length > 0">
                                <!-- No data message -->
                                <div *ngIf="!baseService.provinceChartData && !baseService.isLoading"
                                    class="text-center">
                                    <p class="text-gray-500">No province data available</p>
                                </div>
                                <!-- Single Chart Canvas (only when data ready) -->
                                <div *ngIf="baseService.provinceChartData" class="chart-container">
                                    <div class="chart-wrapper-province">
                                        <app-chart-js chartType="bar" [chartData]="baseService.provinceChartData" [chartOptions]="baseService.provinceChartOptions" height="300px"></app-chart-js>
                                    </div>
                                </div>
                                <h3 class="statistics-heading">Detailed Statistics</h3>
                                <mat-divider></mat-divider>
                                <div class="index-list">
                                    <div *ngFor="let item of baseService.provinceIndexData; let i = index"
                                        class="index-item">
                                        <span class="color-dot" [style.backgroundColor]="item.color"></span>
                                        <div class="point-name">
                                            <span>{{ item.name }}</span>
                                            <div class="point-stuff">
                                                {{ item.percentage }}% - {{ item.count | number }} learners
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </mat-card-content>
                        </mat-card>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 col-lg-6">
                        <div class="row">
                            <div class="col-12 col-md-6 mb-4">
                                <mat-card class="breakdown-card h-100">
                                    <mat-card-header *ngIf="(baseService.incomeData).length > 0">
                                        <mat-card-title class="custom-card-title">
                                            {{ 'Income Breakdown by Learners' }}
                                        </mat-card-title>
                                    </mat-card-header>
                                    <mat-card-content *ngIf="(baseService.incomeData).length === 0">
                                        <mat-spinner diameter="40" aria-label="Loading Data"></mat-spinner>
                                    </mat-card-content>
                                    <mat-card-content *ngIf="(baseService.incomeData).length > 0">
                                        <div *ngFor="let item of (baseService.incomeData); let i = index"
                                            class="breakdown-item">
                                            <div class="d-flex justify-content-between">
                                                <span>{{ item.category }}</span>
                                                <span class="fw-bold">{{ item.percentage }}%</span>
                                            </div>
                                            <mat-progress-bar mode="determinate" [value]="item.percentage"
                                                [ngStyle]="{'--mat-progress-bar-color': baseService.getColor('income', i)}"
                                                [attr.aria-label]="('Income level ') + item.category + ' ' + item.percentage + '%'">
                                            </mat-progress-bar>
                                            <span class="learner-count text-muted">{{ item.count | number }}
                                                learners</span>
                                        </div>
                                    </mat-card-content>
                                </mat-card>
                            </div>
                            <div class="col-12 col-md-6 mb-4">
                                <mat-card class="breakdown-card h-100">
                                    <mat-card-header *ngIf="baseService.ageData.length > 0">
                                        <mat-card-title class="custom-card-title">Age Breakdown by
                                            Learners</mat-card-title>
                                    </mat-card-header>
                                    <mat-card-content *ngIf="baseService.ageData.length === 0">
                                        <mat-spinner diameter="40" aria-label="Loading Age Breakdown"></mat-spinner>
                                    </mat-card-content>
                                    <mat-card-content *ngIf="baseService.ageData.length > 0">
                                        <div *ngFor="let age of baseService.ageData; let i = index"
                                            class="breakdown-item">
                                            <div class="d-flex justify-content-between">
                                                <span>{{ age.category }}</span>
                                                <span class="fw-bold">{{ age.percentage }}%</span>
                                            </div>
                                            <mat-progress-bar mode="determinate" [value]="age.percentage"
                                                [ngStyle]="{'--mat-progress-bar-color': baseService.getColor('age', i)}"
                                                [attr.aria-label]="'Age group ' + age.category + ' ' + age.percentage + '%'">
                                            </mat-progress-bar>
                                            <span class="learner-count text-muted">{{ age.count | number }}
                                                learners</span>
                                        </div>
                                    </mat-card-content>
                                </mat-card>
                            </div>
                            <div class="col-12 col-md-6 mb-4">
                                <mat-card class="breakdown-card h-100">
                                    <mat-card-header *ngIf=" (baseService.educationData).length > 0">
                                        <mat-card-title class="custom-card-title">
                                            {{ 'Education Level by Learners' }}
                                        </mat-card-title>
                                    </mat-card-header>
                                    <mat-card-content *ngIf="(baseService.educationData).length === 0">
                                        <mat-spinner diameter="40" aria-label="Loading Data"></mat-spinner>
                                    </mat-card-content>
                                    <mat-card-content *ngIf="(baseService.educationData).length > 0">
                                        <div *ngFor="let item of (baseService.educationData); let i = index"
                                            class="breakdown-item">
                                            <div class="d-flex justify-content-between">
                                                <span>{{ item.category }}</span>
                                                <span class="fw-bold">{{ item.percentage }}%</span>
                                            </div>
                                            <mat-progress-bar mode="determinate" [value]="item.percentage"
                                                [ngStyle]="{'--mat-progress-bar-color': baseService.getColor('education', i)}"
                                                [attr.aria-label]="( 'Education level ') + item.category + ' ' + item.percentage + '%'">
                                            </mat-progress-bar>
                                            <span class="learner-count text-muted">{{ item.count | number }}
                                                learners</span>
                                        </div>
                                    </mat-card-content>
                                </mat-card>
                            </div>
                            <div class="col-12 col-md-6 mb-4">
                                <mat-card class="breakdown-card h-100">
                                    <mat-card-header *ngIf="baseService.genderData.length > 0">
                                        <mat-card-title class="custom-card-title">Gender Breakdown by
                                            Learners</mat-card-title>
                                    </mat-card-header>
                                    <mat-card-content *ngIf="baseService.genderData.length === 0">
                                        <mat-spinner diameter="40" aria-label="Loading Gender Breakdown"></mat-spinner>
                                    </mat-card-content>
                                    <mat-card-content *ngIf="baseService.genderData.length > 0">
                                        <div *ngFor="let gender of baseService.genderData; let i = index"
                                            class="breakdown-item">
                                            <div class="d-flex justify-content-between">
                                                <span>{{ gender.category }}</span>
                                                <span class="fw-bold">{{ gender.percentage }}%</span>
                                            </div>
                                            <mat-progress-bar mode="determinate" [value]="gender.percentage"
                                                [ngStyle]="{'--mat-progress-bar-color': baseService.getColor('gender', i)}"
                                                [attr.aria-label]="'Gender ' + gender.category + ' ' + gender.percentage + '%'">
                                            </mat-progress-bar>
                                            <span class="learner-count text-muted">{{ gender.count | number }}
                                                learners</span>
                                        </div>
                                    </mat-card-content>
                                </mat-card>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-lg-6 mb-4">
                        <mat-card class="chart-card h-100">
                            <mat-card-header *ngIf="baseService.languageIndexData.length > 0">
                                <div class="card-header-stack">
                                    <div class="card-header-top">
                                        <mat-card-title class="custom-card-title card-title-with-tooltip">
                                            <span class="card-title-text">Learner Breakdown by Language</span>
                                            <button
                                                type="button"
                                                class="what-is-this"
                                                matTooltipClass="dashboard-tooltip"
                                                [matTooltip]="tooltips.text('learnerLanguageSelection')"
                                                aria-label="What is this? Learner Breakdown by Language">
                                                <mat-icon aria-hidden="true">info</mat-icon>
                                                What is this?
                                            </button>
                                        </mat-card-title>
                                        <mat-card-subtitle class="date-label">{{ baseService.dateRange }}</mat-card-subtitle>
                                    </div>

                                    <mat-divider class="header-divider"></mat-divider>

                                    <div class="header-filter-right-wrapper">
                                        <mat-form-field appearance="outline" class="header-filter under-header">
                                            <mat-label>Filter by Language</mat-label>
                                            <mat-select [(ngModel)]="baseService.selectedLanguage"
                                                (selectionChange)="onLanguageFilterChange()" aria-label="Filter by language"
                                                multiple>
                                                <mat-option *ngFor="let language of baseService.languages; let i = index"
                                                    [value]="language.fullName">
                                                    <span class="color-dot"
                                                        [style.backgroundColor]="baseService.colorPalettes['language'][i % baseService.colorPalettes['language'].length]"></span>
                                                    {{ language.fullName }}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>
                                </div>
                            </mat-card-header>
                            <mat-card-content *ngIf="baseService.languageIndexData.length === 0">
                                <mat-spinner diameter="40" aria-label="Loading Language Breakdown"></mat-spinner>
                            </mat-card-content>
                            <mat-card-content *ngIf="baseService.languageIndexData.length > 0">
                                <!-- No Data -->
                                <mat-card-content *ngIf="baseService.languageChartData" class="chart-container">
                                    <div class="chart-wrapper-language">
                                        <app-chart-js chartType="bar" [chartData]="baseService.languageChartData" [chartOptions]="baseService.languageChartOptions" height="250px"></app-chart-js>
                                    </div>
                                </mat-card-content>

                                <mat-card-content *ngIf="!baseService.languageChartData && !baseService.isLoading"
                                    class="text-center">
                                    <p class="text-gray-500">No language data available</p>
                                </mat-card-content>

                                <!-- Chart -->
                                <h3 class="statistics-heading">Detailed Statistics</h3>
                                <mat-divider></mat-divider>
                                <div class="index-list">
                                    <div *ngFor="let item of baseService.languageIndexData; let i = index"
                                        class="index-item">
                                        <span class="color-dot" [style.backgroundColor]="item.color"></span>
                                        <div class="point-name">
                                            <span>{{ item.name }}</span>
                                            <div class="point-stuff">
                                                {{ item.percentage }}% - {{ item.count | number }} learners
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </mat-card-content>
                        </mat-card>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 col-lg-6 mb-4">
                        <mat-card class="chart-list-card h-100">
                            <mat-card-header *ngIf="baseService.locationChartData.length > 0">
                                <mat-card-title class="custom-card-title">Learner Engagement by
                                    Location</mat-card-title>
                            </mat-card-header>
                            <mat-card-content *ngIf="baseService.locationChartData.length === 0">
                                <mat-spinner diameter="40" aria-label="Loading Location Engagement"></mat-spinner>
                            </mat-card-content>
                            <mat-card-content *ngIf="baseService.locationChartData.length > 0">
                                <p class="text-muted date-label">{{ baseService.dateRange }}</p>
                                <div class="d-flex flex-wrap">
                                    <div class="chart-container" style="min-width: 150px; width: 40%;">
                                        <igx-pie-chart [dataSource]="baseService.locationChartData"
                                            labelsMemberPath="category" valueMemberPath="percentage"
                                            [brushes]="baseService.locationColors" width="100%" height="250px"
                                            outlines="white" aria-label="Location pie chart">
                                        </igx-pie-chart>
                                    </div>
                                    <div class="list-container" style="min-width: 180px; width: 60%; margin-top: 50px">
                                        <ul class="metric-list">
                                            <li *ngFor="let location of baseService.locationData">
                                                <div class="d-flex align-items-center">
                                                    <span class="color-dot"
                                                        [style.backgroundColor]="location.color"></span>
                                                    <span>{{ location.category }}</span>
                                                </div>
                                                <div class="pie-items">
                                                    <span class="fw-bold">{{ location.count | number }} - {{
                                                        location.percentage }}%</span>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </mat-card-content>
                        </mat-card>
                    </div>
                    <div class="col-12 col-lg-6 mb-4">
                        <mat-card class="chart-list-card h-100">
                            <mat-card-header *ngIf="baseService.employmentChartData.length > 0">
                                <mat-card-title class="custom-card-title">Learner Breakdown by Employment
                                    Status</mat-card-title>
                            </mat-card-header>
                            <mat-card-content *ngIf="baseService.employmentChartData.length === 0">
                                <mat-spinner diameter="40"
                                    aria-label="Loading Employment Status Breakdown"></mat-spinner>
                            </mat-card-content>
                            <mat-card-content *ngIf="baseService.employmentChartData.length > 0">
                                <p class="text-muted date-label">{{ baseService.dateRange }}</p>
                                <div class="d-flex flex-wrap">
                                    <div class="chart-container" style="min-width: 150px; width: 40%;">
                                        <igx-pie-chart [dataSource]="baseService.employmentChartData"
                                            labelsMemberPath="category" valueMemberPath="percentage"
                                            [brushes]="baseService.employmentColors" width="100%" height="250px"
                                            outlines="white" aria-label="Employment Status pie chart">
                                        </igx-pie-chart>
                                    </div>
                                    <div class="list-container" style="min-width: 180px; width: 60%;">
                                        <ul class="metric-list">
                                            <li *ngFor="let employmentStatus of baseService.employmentData">
                                                <div class="d-flex align-items-center">
                                                    <span class="color-dot"
                                                        [style.backgroundColor]="employmentStatus.color"></span>
                                                    <span>{{ employmentStatus.category }}</span>
                                                </div>
                                                <div class="pie-items">
                                                    <span class="fw-bold">{{ employmentStatus.count | number }} - {{
                                                        employmentStatus.percentage }}%</span>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </mat-card-content>
                        </mat-card>
                    </div>
                </div>
                <div class="row">
                    <div class="col-6 mb-4 offset-6">
                        <mat-card class="chart-list-card h-100">
                            <mat-card-header *ngIf="baseService.disabilityChartData.length > 0">
                                <mat-card-title class="custom-card-title">Learner Breakdown by Disability
                                    Status</mat-card-title>
                            </mat-card-header>
                            <mat-card-content *ngIf="baseService.disabilityChartData.length === 0">
                                <mat-spinner diameter="40"
                                    aria-label="Loading Employment Status Breakdown"></mat-spinner>
                            </mat-card-content>
                            <mat-card-content *ngIf="baseService.disabilityChartData.length > 0">
                                <p class="text-muted date-label">{{ baseService.dateRange }}</p>
                                <div class="d-flex flex-wrap">
                                    <div class="chart-container" style="min-width: 150px; width: 40%;">
                                        <igx-pie-chart [dataSource]="baseService.disabilityChartData"
                                            labelsMemberPath="category" valueMemberPath="percentage"
                                            [brushes]="baseService.disabilityColors" width="100%" height="250px"
                                            outlines="white" aria-label="Employment Status pie chart">
                                        </igx-pie-chart>
                                    </div>
                                    <div class="list-container"
                                        style="min-width: 180px; width: 60%;  margin-top: 50px;">
                                        <ul class="metric-list">
                                            <li *ngFor="let disability of baseService.disabilityData">
                                                <div class="d-flex align-items-center">
                                                    <span class="color-dot"
                                                        [style.backgroundColor]="disability.color"></span>
                                                    <span>{{ disability.category }}</span>
                                                </div>
                                                <div class="pie-items">
                                                    <span class="fw-bold">{{ disability.count | number }} - {{
                                                        disability.percentage }}%</span>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </mat-card-content>
                        </mat-card>
                    </div>
                </div>
            </mat-tab>

            <mat-tab label="Learning Impact">
                <!-- Registration and Completions -->
                <div class="row">
                    <div class="col-12 col-lg-3 mb-4">
                        <mat-card class="summary-card h-100">
                            <mat-card-header *ngIf="!baseService.isLoading">
                                <mat-card-title class="custom-card-title card-title-with-tooltip card-title-tooltip-right">
                                    <span class="card-title-text">Total Enrolled Users</span>
                                    <button
                                        type="button"
                                        class="what-is-this"
                                        matTooltipClass="dashboard-tooltip"
                                        [matTooltip]="tooltips.text('totalRegisteredUsers')"
                                        matTooltipPosition="right"
                                        aria-label="What is this? Total Enrolled Users">
                                        <mat-icon aria-hidden="true">info</mat-icon>
                                        What is this?
                                    </button>
                                </mat-card-title>
                                <mat-card-subtitle class="date-label">{{ baseService.dateRange }}</mat-card-subtitle>
                            </mat-card-header>

                            <mat-card-content>
                                <!-- Loading: Show spinner only when count is 0 -->
                                <div *ngIf="baseService.isLoading" class="text-center p-4">
                                    <mat-spinner diameter="40" aria-label="Loading Enrolled Users"></mat-spinner>
                                </div>

                                <!-- Zero State: No users in period -->
                                <div *ngIf="!baseService.isLoading && baseService.isEnrolledUsersZeroState">
                                    <img src="assets/images/zero_state-column.png" alt="No enrolled users"
                                        class="img-fluid" style="object-fit: contain; height: 30px;">
                                    <mat-card-subtitle class="sub-headings">User Count</mat-card-subtitle>

                                    <div class="d-flex align-items-center justify-content-between mt-auto">
                                        <span class="summary-value">{{ baseService.enrolledUsersTotal | number }}</span>
                                        <div class="percentage-change" [ngClass]="baseService.enrolledUsersChangeClass"
                                            *ngIf="baseService.enrolledUsersChangePercentage">
                                            <mat-icon>{{ baseService.enrolledUsersChangeIcon }}</mat-icon>
                                            <span>0 %</span>
                                        </div>
                                    </div>
                                </div>
                                <!-- Data: Show only when count > 0 -->
                                <div *ngIf="baseService.enrolledUsersTotal > 0">
                                    <img src="assets/images/chartImage.png" alt="Engagement Visual" class="img-fluid"
                                        style="object-fit: contain; height: 30px;" />
                                    <mat-card-subtitle class="sub-headings">User Count</mat-card-subtitle>

                                    <div class="d-flex align-items-center justify-content-between mt-auto">
                                        <span class="summary-value">{{ baseService.enrolledUsersTotal | number }}</span>
                                        <div class="percentage-change" [ngClass]="baseService.enrolledUsersChangeClass"
                                            *ngIf="baseService.enrolledUsersChangePercentage">
                                            <mat-icon>{{ baseService.enrolledUsersChangeIcon }}</mat-icon>
                                            <span>{{ baseService.enrolledUsersChangePercentage }}%</span>
                                        </div>
                                    </div>
                                </div>
                            </mat-card-content>
                        </mat-card>
                    </div>

                    <div class="col-12 col-lg-3 mb-4">
                        <mat-card class="summary-card h-100">
                            <mat-card-header *ngIf="!baseService.isLoading">
                                <mat-card-title class="custom-card-title card-title-with-tooltip">
                                    <span class="card-title-text">Total Users Who Began Course</span>
                                    <button
                                        type="button"
                                        class="what-is-this"
                                        matTooltipClass="dashboard-tooltip"
                                        [matTooltip]="tooltips.text('startedLearning')"
                                        aria-label="What is this? Total Users Who Began Course">
                                        <mat-icon aria-hidden="true">info</mat-icon>
                                        What is this?
                                    </button>
                                </mat-card-title>
                                <mat-card-subtitle class="date-label">{{ baseService.dateRange }}</mat-card-subtitle>
                            </mat-card-header>

                            <mat-card-content>
                                <!-- Loading -->
                                <div *ngIf="baseService.isLoading" class="text-center p-4">
                                    <mat-spinner diameter="40" aria-label="Loading Course Starters"></mat-spinner>
                                </div>
                                <!--Zero Data -->
                                <div *ngIf="!baseService.isLoading && baseService.usersBeganCourseTotal === 0">
                                    <img src="assets/images/zero_state-column.png" alt="No enrolled users"
                                        class="img-fluid" style="object-fit: contain; height: 30px;">
                                    <mat-card-subtitle class="sub-headings">Total Starters</mat-card-subtitle>

                                    <div class="d-flex align-items-center justify-content-between mt-auto">
                                        <span class="summary-value">{{ baseService.usersBeganCourseTotal | number
                                            }}</span>

                                        <div class="percentage-change"
                                            [ngClass]="baseService.usersBeganCourseChangeClass"
                                            *ngIf="baseService.usersBeganCourseChangePercentage !== ''">
                                            <mat-icon>{{ baseService.usersBeganCourseChangeIcon }}</mat-icon>
                                            <span>0 %</span>
                                        </div>
                                    </div>
                                </div>

                                <!-- Data -->
                                <div *ngIf="!baseService.isLoading && baseService.usersBeganCourseTotal > 0">
                                    <img src="assets/images/chartImage.png" alt="Course Start Visual" class="img-fluid"
                                        style="object-fit: contain; height: 30px;" />
                                    <mat-card-subtitle class="sub-headings">Total Starters</mat-card-subtitle>

                                    <div class="d-flex align-items-center justify-content-between mt-auto">
                                        <span class="summary-value">{{ baseService.usersBeganCourseTotal | number
                                            }}</span>

                                        <div class="percentage-change"
                                            [ngClass]="baseService.usersBeganCourseChangeClass"
                                            *ngIf="baseService.usersBeganCourseChangePercentage !== ''">
                                            <mat-icon>{{ baseService.usersBeganCourseChangeIcon }}</mat-icon>
                                            <span>{{ baseService.usersBeganCourseChangePercentage }}%</span>
                                        </div>
                                    </div>
                                </div>
                            </mat-card-content>
                        </mat-card>
                    </div>

                    <!-- CARD 3: Course Completions -->
                    <div class="col-12 col-lg-3 mb-4">
                        <mat-card class="summary-card h-100">
                            <mat-card-header *ngIf="!baseService.isLoading">
                                <mat-card-title class="custom-card-title card-title-with-tooltip">
                                    <span class="card-title-text">Total Course Completions</span>
                                    <button
                                        type="button"
                                        class="what-is-this"
                                        matTooltipClass="dashboard-tooltip"
                                        [matTooltip]="tooltips.text('completedLearning')"
                                        aria-label="What is this? Total Course Completions">
                                        <mat-icon aria-hidden="true">info</mat-icon>
                                        What is this?
                                    </button>
                                </mat-card-title>
                                <mat-card-subtitle class="date-label">{{ baseService.dateRange }}</mat-card-subtitle>
                            </mat-card-header>

                            <mat-card-content>
                                <!-- Loading -->
                                <div *ngIf="baseService.isLoading" class="text-center p-4">
                                    <mat-spinner diameter="40" aria-label="Loading Course Completions"></mat-spinner>
                                </div>

                                <!--Zero Data -->
                                <div *ngIf="!baseService.isLoading && baseService.courseCompletionsTotal === 0">
                                    <img src="assets/images/zero_state-column.png" alt="No enrolled users"
                                        class="img-fluid" style="object-fit: contain; height: 30px;">

                                    <mat-card-subtitle class="sub-headings">Completed All Courses</mat-card-subtitle>

                                    <div class="d-flex align-items-center justify-content-between mt-auto">
                                        <span class="summary-value">{{ baseService.courseCompletionsTotal | number
                                            }}</span>

                                        <div class="percentage-change"
                                            [ngClass]="baseService.courseCompletionsChangeClass"
                                            *ngIf="baseService.courseCompletionsChangePercentage !== ''">
                                            <mat-icon>{{ baseService.courseCompletionsChangeIcon }}</mat-icon>
                                            <span>0 %</span>
                                        </div>
                                    </div>
                                </div>

                                <!-- Data -->
                                <div *ngIf="baseService.courseCompletionsTotal > 0">
                                    <img src="assets/images/chartImage.png" alt="Completion Visual" class="img-fluid"
                                        style="object-fit: contain; height: 30px;" />
                                    <mat-card-subtitle class="sub-headings">Completed All Courses</mat-card-subtitle>

                                    <div class="d-flex align-items-center justify-content-between mt-auto">
                                        <span class="summary-value">{{ baseService.courseCompletionsTotal | number
                                            }}</span>

                                        <div class="percentage-change"
                                            [ngClass]="baseService.courseCompletionsChangeClass"
                                            *ngIf="baseService.courseCompletionsChangePercentage !== ''">
                                            <mat-icon>{{ baseService.courseCompletionsChangeIcon }}</mat-icon>
                                            <span>{{ baseService.courseCompletionsChangePercentage }}%</span>
                                        </div>
                                    </div>
                                </div>
                            </mat-card-content>
                        </mat-card>
                    </div>

                    <!-- CARD 4: Completion Rate -->
                    <div class="col-12 col-lg-3 mb-4">
                        <mat-card class="summary-card h-100 completion-rate-card">
                            <mat-card-header *ngIf="!baseService.isLoading">
                                <mat-card-title class="custom-card-title card-title-with-tooltip">
                                    <span class="card-title-text">Completion Rate</span>
                                    <button
                                        type="button"
                                        class="what-is-this"
                                        matTooltipClass="dashboard-tooltip"
                                        [matTooltip]="tooltips.text('completionRate')"
                                        aria-label="What is this? Completion Rate">
                                        <mat-icon aria-hidden="true">info</mat-icon>
                                        What is this?
                                    </button>
                                </mat-card-title>
                                <mat-card-subtitle class="date-label">{{ baseService.dateRange }}</mat-card-subtitle>
                            </mat-card-header>

                            <mat-card-content>
                                <!-- Loading -->
                                <div *ngIf="baseService.isLoading" class="text-center p-4">
                                    <mat-spinner diameter="40" aria-label="Loading Completion Rate"></mat-spinner>
                                </div>
                                <!--Zero Data -->
                                <div *ngIf="!baseService.isLoading && baseService.completionRateTotal === 0">
                                    <img src="assets/images/zero_state-column.png" alt="No enrolled users"
                                        class="img-fluid" style="object-fit: contain; height: 30px;">

                                    <mat-card-subtitle class="sub-headings">Overall Completion Rate</mat-card-subtitle>

                                    <div class="d-flex align-items-center justify-content-between mt-auto">
                                        <span class="summary-value">{{ baseService.completionRateTotal | number
                                            }}%</span>

                                        <div class="percentage-change" [ngClass]="baseService.completionRateChangeClass"
                                            *ngIf="baseService.completionRateChangePercentage !== ''">
                                            <mat-icon>{{ baseService.completionRateChangeIcon }}</mat-icon>
                                            <span>0 %</span>
                                        </div>
                                    </div>
                                </div>

                                <!-- Data -->
                                <div *ngIf="baseService.completionRateTotal > 0">
                                    <img src="assets/images/chartImage.png" alt="Rate Visual" class="img-fluid"
                                        style="object-fit: contain; height: 30px;" />
                                    <mat-card-subtitle class="sub-headings">Overall Completion Rate</mat-card-subtitle>

                                    <div class="d-flex align-items-center justify-content-between mt-auto">
                                        <span class="summary-value">{{ baseService.completionRateTotal | number
                                            }}%</span>

                                        <div class="percentage-change" [ngClass]="baseService.completionRateChangeClass"
                                            *ngIf="baseService.completionRateChangePercentage !== ''">
                                            <mat-icon>{{ baseService.completionRateChangeIcon }}</mat-icon>
                                            <span>{{ baseService.completionRateChangePercentage }}%</span>
                                        </div>
                                    </div>
                                </div>
                            </mat-card-content>
                        </mat-card>
                    </div>
                </div>
                <div class="row">
                    <div class="col-6 lg-6 mb-4">
                        <mat-card class="chart-card h-100">
                            <mat-card-header *ngIf="baseService.prePostQuizQuestionsIndexData.length > 0">
                                <mat-card-title class="custom-title-learning card-title-with-tooltip">
                                    <span class="card-title-text">Pre/Post Quiz Analysis</span>
                                    <button
                                        type="button"
                                        class="what-is-this"
                                        matTooltipClass="dashboard-tooltip"
                                        [matTooltip]="tooltips.text('prePostQuizAnalysis')"
                                        aria-label="What is this? Pre/Post Quiz Analysis">
                                        <mat-icon aria-hidden="true">info</mat-icon>
                                        What is this?
                                    </button>
                                </mat-card-title>
                                <mat-card-subtitle class="custom-subtitle">Discover insights into pre & post quiz
                                    performance</mat-card-subtitle>
                            </mat-card-header>
                            <mat-divider class="header-divider"></mat-divider>
                            <mat-card-content *ngIf="baseService.prePostQuizQuestionsIndexData.length === 0">
                                <mat-spinner diameter="40" aria-label="Loading Pre/Post Quiz Breakdown"></mat-spinner>
                            </mat-card-content>
                            <mat-card-content *ngIf="baseService.prePostQuizQuestionsIndexData.length > 0">
                                <!-- No Data -->
                                <mat-card-content
                                    *ngIf="!baseService.prePostQuizQuestionsChartData && !baseService.isLoading"
                                    class="text-center">
                                    <p class="text-gray-500">No quiz data available</p>
                                </mat-card-content>
                                <!-- Chart -->
                                <mat-card-content *ngIf="baseService.prePostQuizQuestionsChartData"
                                    class="chart-container">
                                    <div class="chart-wrapper">
                                        <app-chart-js chartType="bar" [chartData]="baseService.prePostQuizQuestionsChartData" [chartOptions]="baseService.prePostQuizChartOptions" height="500px"></app-chart-js>
                                        <!-- ← Added #prePostQuizChartCanvas -->
                                    </div>
                                </mat-card-content>
                                <div class="index-item-quiz">
                                    <div *ngFor="let item of baseService.prePostQuizQuestionsIndexData; let i = index"
                                        class="index-item-quiz">
                                        <span class="color-dot-quiz" [style.backgroundColor]="item.color"></span>
                                        <div class="point-name">
                                            <span>{{ item.quiz }}</span>
                                        </div>
                                    </div>
                                </div>
                            </mat-card-content>
                        </mat-card>
                    </div>
                    <div class="col-6 lg-6 mb-4">
                        <mat-card class="chart-card h-100">
                            <mat-card-header>
                                <mat-card-title class="custom-title-learning card-title-with-tooltip">
                                    <span class="card-title-text">Question by Question Analysis</span>
                                    <button
                                        type="button"
                                        class="what-is-this"
                                        matTooltipClass="dashboard-tooltip"
                                        [matTooltip]="tooltips.text('questionByQuestionAnalysis')"
                                        aria-label="What is this? Question by Question Analysis">
                                        <mat-icon aria-hidden="true">info</mat-icon>
                                        What is this?
                                    </button>
                                </mat-card-title>
                                <mat-card-subtitle class="custom-subtitle">Discover insights into pre & post quiz
                                    performance</mat-card-subtitle>
                            </mat-card-header>
                            <mat-divider class="header-divider"></mat-divider>
                            <!-- Loading / No Data -->
                            <mat-card-content
                                *ngIf="baseService.currentPeriodStats.length === 0 && !baseService.isLoading"
                                class="text-center py-4">
                                <p class="text-gray-500">No quiz data available</p>
                            </mat-card-content>

                            <!-- Table with Scroll -->
                            <mat-card-content *ngIf="baseService.currentPeriodStats.length > 0" class="table-container">
                                <div class="table-scroll">
                                    <table mat-table [dataSource]="baseService.currentPeriodStats"
                                        class="mat-elevation-z4">

                                        <!-- Question Column -->
                                        <ng-container matColumnDef="quizQuestion">
                                            <th mat-header-cell *matHeaderCellDef class="font-bold"
                                                style="color: rgba(123, 128, 154, 1)">Question</th>
                                            <td mat-cell *matCellDef="let element" class="question-text">
                                                {{ element.quizQuestion }}
                                            </td>
                                        </ng-container>

                                        <!-- Pre-Learning % -->
                                        <ng-container matColumnDef="pre_learning_percentage">
                                            <th mat-header-cell *matHeaderCellDef style="color: rgba(123, 128, 154, 1)">
                                                Pre-Quiz</th>
                                            <td mat-cell *matCellDef="let element" style="color:rgba(145, 158, 171, 1)">
                                                {{ element.pre_learning_percentage }}%</td>
                                        </ng-container>

                                        <!-- Post-Learning % -->
                                        <ng-container matColumnDef="post_learning_percentage">
                                            <th mat-header-cell *matHeaderCellDef style="color: rgba(123, 128, 154, 1)">
                                                Post-Quiz</th>
                                            <td mat-cell *matCellDef="let element" style="color:rgba(61, 173, 255, 1)">
                                                {{ element.post_learning_percentage }}%</td>
                                        </ng-container>

                                        <!-- Improvement % -->
                                        <ng-container matColumnDef="improvement_percentage">
                                            <th mat-header-cell *matHeaderCellDef style="color: rgba(123, 128, 154, 1)">
                                                Improvement</th>
                                            <td mat-cell *matCellDef="let element">
                                                <div class="pill" [ngClass]="{
                                            'positive': baseService.isPositive(element.improvement_percentage),
                                            'negative': baseService.isNegative(element.improvement_percentage)
                                            }">
                                                    {{ baseService.isPositive(element.improvement_percentage) ? '↑' :
                                                    (baseService.isNegative(element.improvement_percentage) ? '↓' : '')
                                                    }}
                                                    {{ baseService.isPositive(element.improvement_percentage) ?
                                                    element.improvement_percentage :
                                                    (baseService.isNegative(element.improvement_percentage) ?
                                                    (-element.improvement_percentage | number:'1.0-2') :
                                                    element.improvement_percentage) }}%
                                                </div>
                                            </td>
                                        </ng-container>

                                        <tr mat-header-row
                                            *matHeaderRowDef="baseService.displayedColumns; sticky: true"></tr>
                                        <tr mat-row *matRowDef="let row; columns: baseService.displayedColumns;"></tr>
                                    </table>
                                </div>
                            </mat-card-content>
                        </mat-card>
                    </div>
                </div>
                <!--Quiz Feedback based on percentage-->
                <div class="row">
                    <div class="col-6 sm-6 mb-4">
                        <mat-card class="knowledge-gain-card">
                            <mat-card-header>
                                <mat-card-title class="card-title-assesment card-title-with-tooltip">
                                    <span class="card-title-text">Overall Knowledge Gain</span>
                                    <button
                                        type="button"
                                        class="what-is-this"
                                        matTooltipClass="dashboard-tooltip"
                                        [matTooltip]="tooltips.text('overallKnowledgeGain')"
                                        aria-label="What is this? Overall Knowledge Gain">
                                        <mat-icon aria-hidden="true">info</mat-icon>
                                        What is this?
                                    </button>
                                </mat-card-title>
                            </mat-card-header>
                            <mat-card-content class="knowledge-gain-content">
                                <div class="gain-value">
                                    <span class="gain-number">
                                        {{ baseService.getAverageImprovement() }}%</span>
                                </div>
                                <div class="gain-label">
                                    Combined Learner improvement between pre & post quizzes
                                </div>
                            </mat-card-content>
                        </mat-card>
                    </div>
                    <div class="col-6 sm-6 mb-4">
                        <mat-card class="knowledge-gain-card">
                            <mat-card-header>
                                <mat-card-title class="card-title-assesment card-title-with-tooltip">
                                    <span class="card-title-text">Key Insights</span>
                                    <button
                                        type="button"
                                        class="what-is-this"
                                        matTooltipClass="dashboard-tooltip"
                                        [matTooltip]="tooltips.text('keyInsights')"
                                        aria-label="What is this? Key Insights">
                                        <mat-icon aria-hidden="true">info</mat-icon>
                                        What is this?
                                    </button>
                                </mat-card-title>
                            </mat-card-header>
                            <mat-card-content class=".knowledge-gain-content">
                                <span class="insight-text">
                                    Learners improved their knowledge by an average of {{
                                    baseService.getAverageImprovement()}}% between pre- and post-quizzes
                                </span>
                            </mat-card-content>
                        </mat-card>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 mb-4">
                        <mat-card class="list-card h-100">
                            <mat-card-header *ngIf="baseService.personalFinanceTableData.length > 0">
                                <mat-card-title class="custom-card-title card-title-with-tooltip ">
                                    <span class="card-title-text">{{'Learning Content Progress Overview Zazi Izandi'}}</span>
                                    <button
                                        type="button"
                                        class="what-is-this"
                                        matTooltipClass="dashboard-tooltip"
                                        [matTooltip]="tooltips.text('learningContentProgressOverview')"
                                        aria-label="What is this? Learning Content Progress Overview">
                                        <mat-icon aria-hidden="true">info</mat-icon>
                                        What is this?
                                    </button>
                                </mat-card-title>
                                <mat-card-subtitle class="custom-subtitle">Completion rates and performance
                                    metrics</mat-card-subtitle>
                            </mat-card-header>
                            <mat-card-content *ngIf="baseService.personalFinanceTableData.length === 0">
                                <mat-spinner diameter="40" aria-label="Loading Zazi Izandi Data"></mat-spinner>
                            </mat-card-content>
                            <mat-card-content *ngIf="baseService.personalFinanceTableData.length > 0">
                                <table mat-table [dataSource]="baseService.personalFinanceTableData"
                                    class="completion-table">
                                    <ng-container matColumnDef="name">
                                        <th mat-header-cell *matHeaderCellDef>COURSE NAME</th>
                                        <td mat-cell *matCellDef="let row">{{ row.name }}</td>
                                    </ng-container>
                                    <ng-container matColumnDef="started_course_completion">
                                        <th mat-header-cell *matHeaderCellDef>Learners Enrolled</th>
                                        <td mat-cell *matCellDef="let row">
                                            <div class="completion-cell">
                                                <span class="completion-value">{{ row.students_started | number
                                                    }}</span>
                                            </div>
                                        </td>
                                    </ng-container>
                                    <ng-container matColumnDef="course_completion">
                                        <th mat-header-cell *matHeaderCellDef>COURSE COMPLETIONS</th>
                                        <td mat-cell *matCellDef="let row">
                                            <div class="completion-cell">
                                                <span class="completion-value">{{ row.course_completion | number
                                                    }}</span>
                                            </div>
                                        </td>
                                    </ng-container>
                                    <ng-container matColumnDef="quiz_completion">
                                        <th mat-header-cell *matHeaderCellDef>QUIZ COMPLETIONS</th>
                                        <td mat-cell *matCellDef="let row">
                                            <div class="completion-cell">
                                                <span class="completion-value">{{ row.quiz_completion | number }}</span>
                                            </div>
                                        </td>
                                    </ng-container>
                                    <ng-container matColumnDef="course_shift">
                                        <th mat-header-cell *matHeaderCellDef>COURSE SHIFT</th>
                                        <td mat-cell *matCellDef="let row">
                                            <div class="completion-cell">
                                                <ng-container *ngIf="row.course_completion > 0">
                                                    <div class="percentage-change pill" [ngClass]="{
                                                        'positive': baseService.isPositive(row.course_change_percentage),
                                                        'negative': baseService.isNegative(row.course_change_percentage)
                                                    }">

                                                        {{ baseService.isPositive(row.course_change_percentage) ? '↑' :
                                                        (baseService.isNegative(row.course_change_percentage) ? '↓' :
                                                        '') }}

                                                        {{ baseService.isPositive(row.course_change_percentage) ?
                                                        row.course_change_percentage :
                                                        (baseService.isNegative(row.course_change_percentage) ?
                                                        (-row.course_change_percentage | number:'1.0-2') :
                                                        row.course_change_percentage) }}%
                                                    </div>
                                                </ng-container>

                                                <ng-container *ngIf="row.course_completion === 0">
                                                    <span class="no-data-note"
                                                        style="color: rgba(211, 214, 223, 1); font-size: 12px;">No
                                                        data</span>
                                                </ng-container>
                                            </div>
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="quiz_shift">
                                        <th mat-header-cell *matHeaderCellDef>QUIZ SHIFT</th>
                                        <td mat-cell *matCellDef="let row">
                                            <div class="completion-cell">
                                                <ng-container *ngIf="row.quiz_completion > 0">
                                                    <div class="percentage-change pill" [ngClass]="{
                                                        'positive': baseService.isPositive(row.quiz_change_percentage),
                                                        'negative': baseService.isNegative(row.quiz_change_percentage)
                                                    }">

                                                        {{ baseService.isPositive(row.quiz_change_percentage) ? '↑' :
                                                        (baseService.isNegative(row.quiz_change_percentage) ? '↓' : '')
                                                        }}

                                                        {{ baseService.isPositive(row.quiz_change_percentage) ?
                                                        row.quiz_change_percentage :
                                                        (baseService.isNegative(row.quiz_change_percentage) ?
                                                        (-row.quiz_change_percentage | number:'1.0-2') :
                                                        row.quiz_change_percentage) }}%
                                                    </div>
                                                </ng-container>

                                                <ng-container *ngIf="row.quiz_completion === 0">
                                                    <span class="no-data-note"
                                                        style="color: rgba(211, 214, 223, 1); font-size: 12px;">No
                                                        data</span>
                                                </ng-container>
                                            </div>
                                        </td>
                                    </ng-container>
                                    <tr mat-header-row
                                        *matHeaderRowDef="['name', 'started_course_completion','course_completion', 'quiz_completion', 'course_shift', 'quiz_shift']">
                                    </tr>
                                    <tr mat-row
                                        *matRowDef="let row; columns: ['name', 'started_course_completion','course_completion', 'quiz_completion','course_shift', 'quiz_shift']">
                                    </tr>
                                </table>
                            </mat-card-content>
                        </mat-card>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 mb-4">
                        <mat-card class="chart-card-assesment">
                            <mat-card-content>
                                <mat-card-title class="custom-card-title">Assessment Performance
                                    Overview</mat-card-title>
                                <mat-card-subtitle class="custom-subtitle">Key metrics and trends for your learning
                                    programs</mat-card-subtitle>
                                <!-- No Data -->
                                <div class="row">
                                    <!-- Pre Quiz percentage-->
                                    <div class="col-3 col-sm-3">
                                        <mat-card class="chart-card-performance">
                                            <mat-card-content class="assessment-pie-card-content">
                                                <div class="assessment-pie-chart-stack">
                                                    <mat-card-title class="assessment-pie-card-title">
                                                        <div class="card-title-assesment card-title-with-tooltip">
                                                            <span class="card-title-text">Pre-Test</span>
                                                            <button type="button" class="what-is-this" matTooltipClass="dashboard-tooltip" [matTooltip]="tooltips.text('preTestAssessmentOverview')" aria-label="What is this? Pre-Test">
                                                                <mat-icon aria-hidden="true">info</mat-icon>
                                                                What is this?
                                                            </button>
                                                        </div>
                                                    </mat-card-title>
                                                    <div *ngIf="baseService.preQuizScoresChartData">
                                                        <app-chart-js chartType="doughnut" [chartData]="baseService.preQuizScoresChartData" [chartOptions]="baseService.doughnutChartOptions" [chartPlugins]="[baseService.centerTextPlugin]" height="200px"></app-chart-js>
                                                    </div>
                                                </div>
                                            </mat-card-content>
                                        </mat-card>
                                    </div>
                                    <!-- Post Quiz percentage-->
                                    <div class="col-3 col-sm-3 ">
                                        <mat-card class="chart-card-performance">
                                            <mat-card-content class="assessment-pie-card-content">
                                                <div class="assessment-pie-chart-stack">
                                                    <mat-card-title class="assessment-pie-card-title">
                                                        <div class="card-title-assesment card-title-with-tooltip">
                                                            <span class="card-title-text">Post-Test</span>
                                                            <button type="button" class="what-is-this" matTooltipClass="dashboard-tooltip" [matTooltip]="tooltips.text('postTestAssessmentOverview')" aria-label="What is this? Post-Test">
                                                                <mat-icon aria-hidden="true">info</mat-icon>
                                                                What is this?
                                                            </button>
                                                        </div>
                                                    </mat-card-title>
                                                    <div class="chart-wrapper-postQuiz">
                                                        <app-chart-js chartType="doughnut" [chartData]="baseService.postQuizScoresChartData" [chartOptions]="baseService.doughnutChartOptions" [chartPlugins]="[baseService.centerTextPlugin]" height="200px"></app-chart-js>
                                                    </div>
                                                </div>
                                            </mat-card-content>
                                        </mat-card>
                                    </div>
                                    <div class="col-3 col-sm-3">
                                        <mat-card class="chart-card-performance">
                                            <mat-card-content class="assessment-pie-card-content">
                                                <div class="assessment-pie-chart-stack">
                                                    <mat-card-title class="assessment-pie-card-title">
                                                        <div class="card-title-assesment card-title-with-tooltip">
                                                            <span class="card-title-text">Overall Engagement Rate</span>
                                                            <button type="button" class="what-is-this" matTooltipClass="dashboard-tooltip" [matTooltip]="tooltips.text('overallEngagementRate')" aria-label="What is this? Overall Engagement Rate">
                                                                <mat-icon aria-hidden="true">info</mat-icon>
                                                                What is this?
                                                            </button>
                                                        </div>
                                                    </mat-card-title>
                                                    <div *ngIf="baseService.overAllEngagementChartData" class="chart-wrapper-engagement">
                                                        <app-chart-js chartType="doughnut" [chartData]="baseService.overAllEngagementChartData" [chartOptions]="baseService.doughnutChartOptions" [chartPlugins]="[baseService.centerTextPlugin]" height="200px"></app-chart-js>
                                                    </div>
                                                </div>
                                            </mat-card-content>
                                        </mat-card>
                                    </div>
                                    <!-- Drop off percentage-->
                                    <div class="col-3 col-sm-3">
                                        <mat-card class="chart-card-performance">
                                            <mat-card-content class="assessment-pie-card-content">
                                                <div class="assessment-pie-chart-stack">
                                                    <mat-card-title class="assessment-pie-card-title">
                                                        <div class="card-title-assesment card-title-with-tooltip">
                                                            <span class="card-title-text">Drop-off Rate</span>
                                                            <button type="button" class="what-is-this" matTooltipClass="dashboard-tooltip" [matTooltip]="tooltips.text('dropOffRate')" aria-label="What is this? Drop-off Rate">
                                                                <mat-icon aria-hidden="true">info</mat-icon>
                                                                What is this?
                                                            </button>
                                                        </div>
                                                    </mat-card-title>
                                                    <div *ngIf="baseService.dropOffChartData" class="chart-wrapper-dropOff">
                                                        <app-chart-js chartType="doughnut" [chartData]="baseService.dropOffChartData" [chartOptions]="baseService.doughnutChartOptions" [chartPlugins]="[baseService.centerTextPlugin]" height="200px"></app-chart-js>
                                                    </div>
                                                </div>
                                            </mat-card-content>
                                        </mat-card>
                                    </div>
                                </div>
                            </mat-card-content>
                        </mat-card>
                    </div>

                </div>
                <!--Student feedback-->
                <div class="row">
                    <div class="col-12 col-lg-12 mb-4">
                        <mat-card class="main-summary-card">
                            <mat-card-content class="p-3">
                                <mat-card-title class="custom-card-title card-title-with-tooltip">
                                    <span class="card-title-text">Learner Feedback Summary</span>
                                    <button type="button" class="what-is-this" matTooltipClass="dashboard-tooltip" [matTooltip]="tooltips.text('averageRating')" aria-label="What is this? Learner Feedback Summary">
                                        <mat-icon aria-hidden="true">info</mat-icon>
                                        What is this?
                                    </button>
                                </mat-card-title>
                                <mat-card-subtitle class="custom-subtitle">Discover insights and trends from learner
                                    responses.</mat-card-subtitle>
                                <div *ngIf="baseService.isLoading" class="text-center py-5">
                                    <mat-spinner diameter="50"></mat-spinner>
                                    <p>Loading feedback summary...</p>
                                </div>
                                <div class="row summary-grid">
                                    <div class="col" *ngFor="let item of mAndEData">
                                        <mat-card class="summary-item-card">
                                            <mat-card-content class="text-center">
                                                <div class="summary-image-title">
                                                    <img src="assets/images/{{ item.image }}" alt="Engagement Visual"
                                                        class="img-fluid"
                                                        style="object-fit: contain; height: 30px; background-color: rgba(226, 247, 255, 1);" />
                                                    <span class="learning-summary-card">{{ item.title }}</span>
                                                </div>
                                                <div *ngIf="item.comment" class="comments">{{ item.comment }}</div>
                                                <h2 class="percentage">{{ item.percentage || 0 }}%</h2>
                                                <p class="description">{{ item.description }}</p>
                                                <button *ngIf="item.tooltipKey" type="button" class="what-is-this what-is-this-inline" matTooltipClass="dashboard-tooltip" [matTooltip]="tooltips.text(item.tooltipKey)" aria-label="What is this?">
                                                    <mat-icon aria-hidden="true">info</mat-icon>
                                                    What is this?
                                                </button>
                                            </mat-card-content>
                                        </mat-card>
                                    </div>
                                </div>
                            </mat-card-content>
                        </mat-card>
                    </div>
                </div>

                <!-- Aggregate amounts-->
                <div class="row">
                    <div class="col-6 col-lg-6 mb-4">
                        <mat-card class="chart-card h-100">
                            <mat-card-content>
                                <mat-card-title class="custom-card-title card-title-with-tooltip">
                                    <span class="card-title-text">Feedback Rating Over Time</span>
                                    <button type="button" class="what-is-this" matTooltipClass="dashboard-tooltip" [matTooltip]="tooltips.text('feedbackRatingOverTime')" aria-label="What is this? Feedback Rating Over Time">
                                        <mat-icon aria-hidden="true">info</mat-icon>
                                        What is this?
                                    </button>
                                </mat-card-title>
                                <mat-card-subtitle class="custom-subtitle">Track the average learner ratings over
                                    time.</mat-card-subtitle>
                                <mat-divider
                                    style="color: rgba(239, 239, 239, 1) !important; margin-top: 2px; margin-bottom: 5px "></mat-divider>
                                <div *ngIf="baseService.isLoading" class="text-center py-5">
                                    <mat-spinner diameter="50"></mat-spinner>
                                </div>
                                <div *ngIf="baseService.mAndEChartData?.labels?.length">
                                    <app-chart-js chartType="bar" [chartData]="baseService.mAndEChartData" [chartOptions]="baseService.mAndEChartOptions" height="408px"></app-chart-js>
                                </div>
                            </mat-card-content>
                        </mat-card>
                    </div>
                    <div class="col-6 col-lg-6 mb-4">
                        <div class="row mb-4">
                            <div class="col md-4" *ngFor="let item of baseService.mAndEConfig.slice(0, 2)">
                                <mat-card class="h-100 summary-item-card border-0 shadow-sm">
                                    <mat-card-content class="text-center p-4">
                                        <div class="summary-image-heading">
                                            <img [src]="'assets/images/' + item.image + '.png'" alt="{{ item.title }}"
                                                class="img-fluid"
                                                style="object-fit: contain; height: 50px; background-color: rgba(226, 247, 255, 1); border-radius: 12px; padding: 8px;" />
                                            <h3 class="title fw-bold text-dark mb-0">{{ item.title }}</h3>
                                        </div>
                                        <div *ngIf="item.comment" class="comments">{{ item.comment }}</div>
                                        <h2 class="value display-5 fw-bold mb-2" style="margin-top: 20px;"
                                            [style.color]="item.color || '#1976d2'">
                                            {{ item.numberMatch }}
                                        </h2>
                                        <p class="description text-muted small">{{ item.description }}</p>
                                        <button *ngIf="item.tooltipKey" type="button" class="what-is-this what-is-this-inline" matTooltipClass="dashboard-tooltip" [matTooltip]="tooltips.text(item.tooltipKey)" aria-label="What is this?">
                                            <mat-icon aria-hidden="true">info</mat-icon>
                                            What is this?
                                        </button>
                                    </mat-card-content>
                                </mat-card>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col md-4" *ngFor="let item of baseService.mAndEConfig.slice(2, 4)">
                                <mat-card class="h-100 summary-item-card border-0 shadow-sm">
                                    <mat-card-content class="text-center p-4">
                                        <div class="summary-image-heading">
                                            <img [src]="'assets/images/' + item.image + '.png'" alt="{{ item.title }}"
                                                class="img-fluid"
                                                style="object-fit: contain; height: 50px; background-color: rgba(226, 247, 255, 1); border-radius: 12px; padding: 8px;" />
                                            <h3 class="title fw-bold text-dark mb-0">{{ item.title }}</h3>
                                        </div>
                                        <div *ngIf="item.comment" class="comments">{{ item.comment }}</div>
                                        <h2 class="value display-5 fw-bold mb-2" style="margin-top: 20px;"
                                            [style.color]="item.color || '#1976d2'">
                                            {{ item.numberMatch }}
                                        </h2>
                                        <p class="description text-muted small">{{ item.description }}</p>
                                        <button *ngIf="item.tooltipKey" type="button" class="what-is-this what-is-this-inline" matTooltipClass="dashboard-tooltip" [matTooltip]="tooltips.text(item.tooltipKey)" aria-label="What is this?">
                                            <mat-icon aria-hidden="true">info</mat-icon>
                                            What is this?
                                        </button>
                                    </mat-card-content>
                                </mat-card>
                            </div>
                        </div>
                    </div>
                </div>
            </mat-tab>
        </mat-tab-group>
    </div>
</div>